import { RadioGroup } from "@outschool/backpack";
import { Search as SearchFilters } from "@outschool/business-rules";
import { SearchFilters as SearchFiltersType } from "@outschool/gql-backend-generated";
import {
  useCurrencyLocalization,
  useLocalPriceDisplay,
  useTranslation,
} from "@outschool/localization";
import { Filter, FilterList } from "@outschool/ui-components-website";
import React from "react";

import usePriceFilterString from "../../hooks/usePriceFilterString";
import FilterActionButtons from "./desktop/FilterActionButtons";

type PricePerMeetingFilterProps = {
  handleChangesExternally?: boolean;
  onCancel: () => void;
  onChange: (value: $TSFixMe) => void;
  value: SearchFiltersType;
};

export default function PricePerMeetingFilter({
  handleChangesExternally,
  onCancel,
  onChange,
  value,
}: PricePerMeetingFilterProps) {
  const { t } = useTranslation(
    "client\\components\\search\\PricePerMeetingFilter",
  );
  const [pricePerMeeting, setPricePerMeeting] = React.useState(value || {});
  const { displayPricePerMeeting } = useLocalPriceDisplay();
  const { currencyCode } = useCurrencyLocalization();
  const { getTranslatedPricePerMeetingStrings } = usePriceFilterString();

  const handleFilterChange = (_e: any, value: string) => {
    const parsedValue = JSON.parse(value);
    setPricePerMeeting(parsedValue);
    if (handleChangesExternally) {
      onChange(parsedValue);
    }
  };
  const priceOptions = SearchFilters.PRICE_PER_MEETING_OPTIONS;

  return (
    <FilterList>
      <Filter title={t("Price per class ({{currencyCode}})", { currencyCode })}>
        <RadioGroup
          name="price_per_meeting"
          value={JSON.stringify(pricePerMeeting)}
          options={priceOptions.map(pricePerMeetingOption => ({
            label: displayPricePerMeeting(
              pricePerMeetingOption as any,
              getTranslatedPricePerMeetingStrings,
            ),
            value: JSON.stringify(pricePerMeetingOption),
          }))}
          onChange={handleFilterChange}
        />
      </Filter>
      {handleChangesExternally ? null : (
        <FilterActionButtons
          onApply={() => onChange(pricePerMeeting)}
          onCancel={onCancel}
        />
      )}
    </FilterList>
  );
}
